<template>
  <Modal :is-open="isOpen" max-width="max-w-[33%] mx-5" default-success-msg="Success">
    <template #form="{ close: closeModal }">
      <h3 class="text-2xl leading-10 font-medium text-gray-900 text-center capitalize dark:text-white">
        <span>{{ $t("Delete") }} {{ selectedRecord.type == "company" ? "Company" : selectedRecord.type }} </span>
      </h3>

      <div class="bg-white dark:bg-dark-screen-background rounded-lg mt-2 mb-2 dark:text-white px-4 pb-4 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <div class="mt-2">
              <p class="text-gray-500">
                {{ $t("Do you want to delete") }} {{ selectedRecord.type == "company" ? "Company" : selectedRecord.type }}
                {{ Record.from(selectedRecord).name }} ?
              </p>
            </div>
            <div v-if="selectedRecord.children.length > 0 && !is_one_of_main_company_parents" class="mt-2">
              <p>
                <span class="text-red-500">{{ $t("NOTE") }} - </span> {{ $t("You can delete") }} "{{ Record.from(selectedRecord).name }}"
                {{ $t("and all related entities") }} {{ $t("OR delete only") }} "{{ Record.from(selectedRecord).name }}"
                {{ $t("and keep all related entities.") }}
              </p>
            </div>
            <div class="mt-3 flex">
              <input
                id="delete_origin"
                v-model="delete_from_origin_checked"
                name="delete_origin"
                type="checkbox"
                class="h-5 w-5 text-blue focus:ring-blue-light border-gray-300 rounded dark:border-dark-divider-border dark:bg-dark-screen-background">
              <label for="delete_origin" class="ml-2 text-sm text-gray-500">
                {{ $t("Remove from origin") }} ({{ selectedRecord.origin == "salesforce" ? $t("Salesforce") : $t("RevSetter") }})
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button
          v-if="is_one_of_main_company_parents"
          type="button"
          class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-red-400 text-base font-medium text-white hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-light sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          @click="deleteNodeOrigin(false, closeModal)">
          <span>{{ $t("Yes") }}</span>
        </button>
        <div v-else>
          <button
            v-if="selectedRecord.children.length > 0"
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-red-400 text-base font-medium text-white hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-light sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            @click="deleteNodeOrigin(false, closeModal)">
            {{ $t("Yes, remove ONLY") }} {{ Record.from(selectedRecord).name }}
          </button>
          <button
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-red-400 text-base font-medium text-white hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-light sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            @click="deleteNodeOrigin(true, closeModal)">
            <span v-if="selectedRecord.children.length == 0">{{ $t("Yes") }}</span>
            <span v-else>{{ $t("Yes, remove ALL") }}</span>
          </button>
        </div>
        <button
          type="button"
          class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white dark:bg-dark-box-background dark:text-white dark:border-dark-divider-border text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-light sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          @click="$emit('update:isOpen', false)">
          {{ $t("Cancel") }}
        </button>
      </div>
    </template>
  </Modal>
</template>
<script>
import Modal from "@/components/shared/Modal.vue"
import dataService from "@/services/data.service"
import { Record } from "@/models/record"
export default {
  components: {
    Modal
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedRecord: {
      type: Object
    }
  },
  emits: ["updateMap", "update:isOpen"],
  data() {
    return {
      Record,
      delete_from_origin_checked: false,
      is_one_of_main_company_parents: false
    }
  },

  watch: {
    selectedRecord() {
      this.is_one_of_main_company_parents = this.isOneOfMainCompanyParents(this.selectedRecord)
    }
  },

  methods: {
    isOneOfMainCompanyParents(m_record) {
      if (!m_record?.children) {
        return false
      }
      return m_record.children.some((record) => {
        if (record.id == this.$store.state.ui.currentCompany.id) {
          return true
        } else {
          return this.isOneOfMainCompanyParents(record)
        }
      })
    },
    deleteNodeOrigin(delete_all, callback) {
      if (delete_all) {
        // Delete Node and all his entities
        let nested_record_list = []
        this.getRecordNestedIds(this.selectedRecord, nested_record_list)
        Promise.all(
          nested_record_list.map(
            (record_id) =>
              new Promise((resolve) => {
                dataService.deleteRecord(record_id).then(() => resolve())
              })
          )
        ).then(() => {
          this.$emit("updateMap")
          this.$emit("update:isOpen", false)
          callback()
        })
      } else {
        // Delete Node only and move up his entities one level
        // this.deleteNodeOnlyById(this.selectedRecord.id)

        Promise.all(
          this.selectedRecord?.children.map(
            (record) =>
              new Promise((resolve) => {
                this.$store
                  .dispatch("data/updateRecord", { record_id: record.id, data: { parent: this.selectedRecord.parent } })
                  .then(() => {
                    resolve()
                  })
              })
          )
        ).then(() => {
          this.$emit("updateMap")
          this.$emit("update:isOpen", false)
          callback()
        })
      }
    },
    // Recursive delete
    deleteRecords(record) {
      if (record?.children.length > 0) {
        record.children.forEach((rec) => {
          this.deleteRecords(rec.id)
        })
      } else {
        return dataService.deleteRecord(record.id)
      }
    },
    getRecordNestedIds(record, list = []) {
      if (record?.children.length > 0) {
        list.push(record.id)
        record.children.forEach((rec) => {
          return this.getRecordNestedIds(rec, list)
        })
      } else {
        return list.push(record.id)
      }
    }
  }
}
</script>

<style scoped>
.org-tree-container {
  background-color: transparent !important;
}
.org-tree-node-label-inner {
  padding: 0px !important;
}
#HiddenNode {
  display: none;
}
.ghostItem {
  @apply bg-gray-900 border-0;
}
.chosenItem {
  @apply bg-transparent border-0;
}
.ghost {
  @apply bg-gray-900 border-0;
}
.chosen {
  @apply bg-gray-700 border-0;
}
</style>
